import {
  Box,
  Button,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material'
import { useMemo, useState } from 'react'

import useAccessTokenAndShopId from '../../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { useGetInventoryInstancesQuery } from '../../../redux/api'
import { InventoryPartEntry } from '../../../sdk'
import { CenteredLoading } from '../../CenteredLoading/CenteredLoading'
import CounterSaleInstanceItem from './CounterSaleInstanceItem'

interface Props {
  inventoryPart: InventoryPartEntry
  closeDialog: () => void
}

const CounterSaleInstanceStore = ({ inventoryPart, closeDialog }: Props) => {
  const { accessToken, shopId } = useAccessTokenAndShopId()
  const { data: instances, isLoading } = useGetInventoryInstancesQuery(
    {
      authorization: accessToken,
      shop: shopId,
      inventoryPart: inventoryPart.id!,
      isNotCore: true,
      isClaimed: false,
      isMarkedForReturnNotReturned: false,
      isReturned: false,
      isLost: false
    },
    { skip: !inventoryPart.id }
  )

  const [page, setPage] = useState(0)
  const pageSize = 10

  const paginatedInstances = useMemo(
    () => (instances || []).slice(page * pageSize, page * pageSize + pageSize),
    [instances, page]
  )

  if (isLoading) {
    return <CenteredLoading />
  }

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between">
        <Button
          disabled={page === 0}
          onClick={() => setPage((prevPage) => prevPage - 1)}>
          Previous
        </Button>
        <Button
          disabled={(page + 1) * pageSize > (instances || []).length}
          onClick={() => setPage((prevPage) => prevPage + 1)}>
          Next
        </Button>
      </Stack>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} size="small">
          <TableHead>
            <TableRow>
              <TableCell>Row</TableCell>
              <TableCell>Invoice Number</TableCell>
              {inventoryPart.info?.isFluids && (
                <>
                  <TableCell>Volume</TableCell>
                  <TableCell>Unit of Measure</TableCell>
                </>
              )}
              <TableCell>Retail Price</TableCell>
              <TableCell>Vendor Name</TableCell>
              <TableCell>Buy</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedInstances.map((instance, index) => (
              <CounterSaleInstanceItem
                key={instance.id}
                instance={instance}
                row={page * pageSize + index + 1}
                isFluids={!!inventoryPart.info?.isFluids}
                closeDialog={closeDialog}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default CounterSaleInstanceStore
